import addFavoriteFolderV2 from '../actions/v2/addFavoriteFolderV2';
import { default as folderStore, Folder } from 'owa-folders';
import { getGuid } from 'owa-guid';
import { orchestrator } from 'satcheljs';
import createOutlookFavoriteService from '../services/v2/createOutlookFavoriteService';
import { convertEWSFolderIdToRestFolderId } from '../utils/ewsRestFolderIdConverter';
import { OutlookFavoriteServiceDataType, FavoriteFolderData } from 'owa-favorites-types';
import { convertServiceResponseToFavoriteData } from '../utils/favoriteServiceDataUtils';
import {
    addFavoriteToStore,
    addFavoriteCompleted,
    addFavoriteFailed,
} from '../actions/v2/addFavoriteActions';
import isOutlookFavoritingInProgress from '../selectors/v2/isOutlookFavoritingInProgress';

/**
 * Add a folder to the favorite store
 * @param folderIdToAdd the id to update
 * @param state the state which contains outlookFavoriteFolders and orderedOutlookFavoritesIds
 */

export default orchestrator(addFavoriteFolderV2, async actionMessage => {
    const { folderIdToAdd } = actionMessage;
    const folder = folderStore.folderTable.get(folderIdToAdd);

    const temporaryGuid = getGuid();
    const favoriteFolderData = createClientFavoriteFolderData(
        temporaryGuid,
        folder,
        false /* isMigration */
    );

    if (isOutlookFavoritingInProgress(folderIdToAdd)) {
        // No-op, an operation is in progress
        return;
    }

    // Local update to add Folder to favorites store
    addFavoriteToStore(favoriteFolderData);

    const owsFavoriteFolderData = createOwsFavoriteFolderData(folder, false /* isMigration */);

    // Use Favorite Roaming API to create a new outlook favorite
    createOutlookFavoriteService(owsFavoriteFolderData)
        .then(response => {
            const asFolder = convertServiceResponseToFavoriteData(response, 'folder');
            addFavoriteCompleted(favoriteFolderData, asFolder);
        })
        .catch(error => {
            addFavoriteFailed(error, favoriteFolderData);
        });
});

export function createClientFavoriteFolderData(
    favoriteId: string,
    folder: Folder,
    isMigration: boolean
): FavoriteFolderData {
    return {
        treeType: 'favorites',
        type: 'folder',
        favoriteId: favoriteId,
        displayName: folder.DisplayName,
        folderId: folder.FolderId.Id,
        client: isMigration ? 'Migration' : 'OWA',
    };
}

export function createOwsFavoriteFolderData(
    folder: Folder,
    isMigration: boolean
): OutlookFavoriteServiceDataType {
    return {
        Type: 'folder',
        DisplayName: folder.DisplayName,
        SingleValueSettings: [
            {
                Key: 'FolderId',
                Value: convertEWSFolderIdToRestFolderId(folder.FolderId.Id),
            },
            {
                Key: 'ChangeKey',
                Value: folder.FolderId.ChangeKey,
            },
        ],
        Client: isMigration ? 'Migration' : 'OWA',
    };
}
